var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "translates p-3" },
    [
      _c(
        "b-tabs",
        {
          scopedSlots: _vm._u([
            {
              key: "tabs-end",
              fn: function () {
                return [
                  _c(
                    "b-nav-item",
                    {
                      attrs: { role: "presentation", href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.newTab.apply(null, arguments)
                        },
                      },
                    },
                    [_c("b", [_vm._v("+")])]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "empty",
              fn: function () {
                return [
                  _c("div", { staticClass: "text-center text-muted" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.__t("EMPTY_LANGUAGES")) +
                        "\n            "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "b-tab",
            {
              key: "lang_tab-" + tab.uniq_id,
              attrs: { title: _vm.get_tab_title(tab) },
            },
            [
              _c("div", { staticClass: "language_block mb-4 mt-4" }, [
                _c("div", { staticClass: "form-group mt-2" }, [
                  _c(
                    "label",
                    { staticClass: "form-label", attrs: { for: "locale" } },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.__t("LOCALE")) +
                          "\n                        "
                      ),
                      parseInt(tab.locale_id) > 0
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-xs btn-dark waves-effect waves-themed",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.make_ai_translate(
                                    tab.locale_id,
                                    tab
                                  )
                                },
                              },
                            },
                            [_vm._v("AI translate")]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.locales.length > 0
                    ? _c(
                        "div",
                        {},
                        [
                          _c(
                            "v-select",
                            {
                              staticClass: "imc_reasons",
                              attrs: {
                                label: "name",
                                reduce: function (locale) {
                                  return locale.id
                                },
                                options: _vm.select_locales,
                                filterable: false,
                                selectable: function (option) {
                                  return option.can_select
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "option",
                                    fn: function (option) {
                                      return [
                                        _c("div", { staticClass: "d-center" }, [
                                          _c("div", [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(option.name) +
                                                "\n                                        "
                                            ),
                                            _c("div", [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "small badge border border-info text-info mr-1",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(option.site_code)
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                              model: {
                                value: tab.locale_id,
                                callback: function ($$v) {
                                  _vm.$set(tab, "locale_id", $$v)
                                },
                                expression: "tab.locale_id",
                              },
                            },
                            [
                              _c("template", { slot: "no-options" }, [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.__t("SELECT_LOCALE")) +
                                    "\n                            "
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "fields" },
                  [
                    _c(
                      "b-overlay",
                      { attrs: { show: _vm.is_ai_work } },
                      _vm._l(tab.fields, function (field) {
                        return _c("div", { staticClass: "form-group mt-2" }, [
                          _c(
                            "label",
                            {
                              staticClass: "form-label",
                              attrs: { for: "advanced" + field.type },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.__t("FIELD_" + field.type)) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "input-group flex-nowrap" },
                            [
                              _c(
                                "div",
                                { staticClass: "input-group-prepend" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "input-group-text" },
                                    [
                                      _c("i", {
                                        staticClass: "fal fa-typewriter fs-xl",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              field.type != "description"
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: field.val,
                                        expression: "field.val",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { id: "ctg_ordering", type: "text" },
                                    domProps: { value: field.val },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          field,
                                          "val",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  })
                                : _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: field.val,
                                        expression: "field.val",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { id: "description", type: "text" },
                                    domProps: { value: field.val },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          field,
                                          "val",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                            ]
                          ),
                        ])
                      }),
                      0
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: { size: "sm", variant: "danger" },
                  on: {
                    click: function ($event) {
                      return _vm.closeTab(tab.uniq_id)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t("REMOVE")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }